import * as requests from "../coraWebComponents/utils/requests";
import { strToDate } from '../coraWebComponents/utils/convert';
import urls from "../constants/Urls";

const buildSprava = (id = "") => {
  return `${urls.ZP_SPRAVY_UZ}/${id}`;
};

export const updateSprava = async (data) => {
  const url = `${buildSprava()}update`;

  try {
    let res = await requests.put(url, data);
    return res;
  } catch (error) {
    throw error;
  }
};

export const getSprava = async (id) => {
  if (id === 0) return null;

  const url = buildSprava(id);
  try {
    let res = await requests.get(url);
    return res;
  } catch (error) {
    throw error;
  }
};

export const getListSprava = async (filter, sort, page) => {
  const url = buildSprava();

  try {
    let res = await requests.getList(url, filter, sort, page);
    return res;
  } catch (error) {
    throw error;
  }
};

export const getListSpravaCurrentUser = async (filter, sort, page) => {
  const url = `${buildSprava()}`;

  try {
    let res = await requests.getList(url, filter, sort, page);
    res.Data.Items.forEach((item) => {
      item.D_PRECITANE = strToDate(item.D_PRECITANE);
      item.ZP_SPRAVY_D_DO = strToDate(item.ZP_SPRAVY_D_DO);
      item.ZP_SPRAVY_D_PUB = strToDate(item.ZP_SPRAVY_D_PUB);
    });
    return res;
  } catch (error) {
    throw error;
  }
};

export const getCountNeprecitaneSpravy = async (I_ORGAN) => {
  const url = `${buildSprava()}neprecitane/count/${I_ORGAN}`;

  try {
    return await requests.get(url);
  } catch (error) {
    throw error;
  }
};
